import { render, staticRenderFns } from "./auto-text.vue?vue&type=template&id=4f64331a&"
import script from "./auto-text.vue?vue&type=script&lang=js&"
export * from "./auto-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports